import React from 'react'

export const ErrorPage = () => <p>Not Found!</p>
